//TODO remove on production
import { Amplify, API } from 'aws-amplify';
const AWS = require('aws-sdk');
import { useAuth } from './auth';
import awsmobile from './../aws-exports';
import { awsAccessKeyId, awsSecretAccessKey } from 'utils/constants';

Amplify.configure(awsmobile);
API.configure(awsmobile);

const region = awsmobile.aws_appsync_region;

AWS.config.update({
  region,
  accessKeyId: awsAccessKeyId,
  secretAccessKey: awsSecretAccessKey,
});

const { getCurrentLoggedUserParams, getAccessToken } = useAuth();

let email;
const customPost = async (API, { query, variables, limitless }) => {
  /**
   * @desc Recursively fetch all items in a list query using nextToken
   * @param {Object} query The query object from cda-graphql in use.
   * @param {Object} input The input to pass to query.
   * @returns {Object} aws query-like result object.
   */

  try {
    try {
      const params = await getCurrentLoggedUserParams();
      email = params.email;
    } catch (e) {
      console.error(e);
    }
    const accessToken = await getAccessToken();
    return lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/drupalquery',
      body: { query, variables, accessToken, limitless, email },
    });
  } catch (err) {
    console.error(err);
    return { error: 'no auth cookie found' };
  }
};

const getLoggedUserEmail = async () => {
  let email;
  try {
    const params = await getCurrentLoggedUserParams();
    email = params.email;
  } catch (e) {
    // prettier-ignore
    //##token##
    console.error(e);
  }
  if (!email) {
    throw new Error('Undefined Email');
  }
  return email;
};

const sendMailPost = async (
  API,
  {
    mail_type,
    mail_to,
    brand_message,
    brand_name,
    br_date,
    br_topic,
    br_image,
    br_start,
    br_end,
    timezone,
    langcode,
    is_live_chat,
  }
) => {
  /**
   * @desc Recursively fetch all items in a list query using nextToken
   * @param {Object} query The query object from cda-graphql in use.
   * @param {Object} input The input to pass to query.
   * @returns {Object} aws query-like result object.
   */

  try {
    try {
      const params = await getCurrentLoggedUserParams();
      email = params.email;
    } catch (e) {
      console.error(e);
    }
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/drupalmail',
      body: {
        mail_type,
        mail_to,
        brand_message,
        brand_name,
        br_date,
        br_topic,
        br_image,
        br_start,
        br_end,
        timezone,
        accessToken,
        email,
        langcode,
        is_live_chat,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: 'no auth cookie found' };
  }
};

const sendMailAgendaPost = async (
  API,
  {
    userName,
    userLastname,
    userEmail,
    userSalesforceId,
    userCompany,
    brandName,
    brandSalesforceId,
    brandEmail,
    date,
    start,
    end,
    pavillion,
    stand,
    referentName,
    note,
    type,
  }
) => {
  /**
   * @desc Recursively fetch all items in a list query using nextToken
   * @param {Object} query The query object from cda-graphql in use.
   * @param {Object} input The input to pass to query.
   * @returns {Object} aws query-like result object.
   */

  try {
    try {
      const params = await getCurrentLoggedUserParams();
      email = params.email;
    } catch (e) {
      console.error(e);
    }
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/drupalAgendaMail',
      body: {
        userName,
        userLastname,
        userEmail,
        userSalesforceId,
        userCompany,
        brandName,
        brandSalesforceId,
        brandEmail,
        date,
        start,
        end,
        pavillion,
        stand,
        referentName,
        note,
        type,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: 'no auth cookie found' };
  }
};

const getPresignedFromLambda = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const preSignedResponse = await lambdaPost(API, {
      apiName: 'sdmBrSettingsApi',
      path: '/getPresignedUrl',

      body: {
        ...params,
        accessToken,
        email,
      },
    });
    return preSignedResponse?.url;
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const deleteBucketObject = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const deleteResponse = await lambdaPost(API, {
      apiName: 'sdmBrSettingsApi',
      path: '/deleteObject',
      body: {
        ...params,
        accessToken,
        email,
      },
    });
    return deleteResponse?.message;
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const createStripeSession = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/generatePaymentIntent',

      body: {
        ...params,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const getTicketPdf = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/ticketPdf',
      body: {
        ...params,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const customApiLambda = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/drupal-custom-api',
      body: {
        ...params,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureSearch = async (API, params, accountIds = []) => {
  try {
    return await lambdaPost(API, {
      apiName: 'sdmAzureApi',
      path: '/exhibitorSearch',
      body: {
        params,
        ...(accountIds?.length && {
          accountIds: accountIds,
        }),
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureAnalyticsSearch = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/analyticsSearch',
      body: {
        params,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureGetExhibitor = async (API, brandId) => {
  try {
    return await lambdaPost(API, {
      apiName: 'sdmAzureApi',
      path: '/getBrand',
      body: {
        brandId,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const getEntityFieldsForm = async (API, params) => {
  try {
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/entityFieldsForm',
      body: {
        params,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const getEntityReferenceRevisionsFieldsForm = async (API, params) => {
  try {
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/entityReferenceRevisionsFieldsForm',
      body: {
        params,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureTicketingLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { params, customMethod, data, federationId } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/ticketing',
      body: {
        params,
        customMethod,
        data: data.data,
        accessToken,
        email,
        federationId,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureMatchmakingLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { params, customMethod, data, federationId } = genericData;
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/matchmaking',
      body: {
        params,
        customMethod,
        data: data.data,
        accessToken,
        email,
        federationId,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureFlexLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { params, customMethod, data, federationId } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/ticketingOrders',
      body: {
        params,
        customMethod,
        data: data.data,
        accessToken,
        email,
        federationId,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureSalesforceCustomerLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { federationId } = genericData;
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/salesforceCustomer',
      body: {
        federationId,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureAggregateTicketingLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { loggedUserType, federationId, isPrd } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/ticketingAggregateData',
      body: {
        loggedUserType,
        federationId,
        isPrd: isPrd || false,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const internalCheckCodeLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { code, year } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/check-code',
      body: {
        code,
        selectedYear: year,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const internalCheckCodesBeforeOrderLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { codes, year, operatorName, operatorSalesforceId } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/check-codes-before-order',
      body: {
        codes,
        selectedYear: year,
        operatorName,
        operatorSalesforceId,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const develonAggregatePersonalTicketLambda = async (API, genericData) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { federationId, ids } = genericData;
    return await lambdaPost(API, {
      apiName: 'sdmStripeApi',
      path: '/develonPersonalTicketsAggregate',
      body: {
        federationId,
        accessToken,
        email,
        ids,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const azureAnalyticsTicketHandler = async (API, params) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();
    const { customMethod, param, salesforceId } = params;
    const scanType = params.scanType || false;
    return await lambdaPost(API, {
      apiName: 'authendpoint',
      path: '/ticketHandler',
      body: {
        customMethod,
        param,
        salesforceId,
        ...(scanType && { scanType }),
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const agendaHandler = async (API, params, path) => {
  try {
    const email = await getLoggedUserEmail();
    const accessToken = await getAccessToken();

    return await lambdaPost(API, {
      apiName: 'sdmAppointmentApi',
      path: path,
      body: {
        ...params,
        accessToken,
        email,
      },
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

const lambdaPost = (API, { apiName, path, body }) => {
  try {
    return API.post(apiName, path, {
      body,
    });
  } catch (err) {
    console.error(err);
    return { error: err.message || 'undefined error' };
  }
};

export default {
  API: {
    post: (query, variables, limitless) =>
      customPost(API, { query, variables, limitless }),
    lambdaPost: (apiName, path, body) =>
      lambdaPost(API, { apiName, path, body }),
    //TODO: move out -> useRemoteStorage hook
    getPresignedFromLambda: (params) => getPresignedFromLambda(API, params),
    //TODO: move out -> useRemoteStorage hook
    deleteBucketObject: (params) => deleteBucketObject(API, params),
    //TODO: move out -> useAzureApi hook
    azureSearch: (params, accountIds = []) =>
      azureSearch(API, params, accountIds),
    //TODO: move out -> useAzureApi hook
    azureAnalyticsSearch: (params) => azureAnalyticsSearch(API, params),
    getEntityFieldsForm: (params) => getEntityFieldsForm(API, params),
    getEntityReferenceRevisionsFieldsForm: (params) =>
      getEntityReferenceRevisionsFieldsForm(API, params),
    azureGetExhibitor: (brandId) => azureGetExhibitor(API, brandId),
    /**
     * Ticketing logic
     */
    createStripeSession: (params) => createStripeSession(API, params),
    azureTicketingLambda: (params) => azureTicketingLambda(API, params),
    azureMatchmakingLambda: (params) => azureMatchmakingLambda(API, params),
    azureFlexLambda: (params) => azureFlexLambda(API, params),
    azureAggregateTicketingLambda: (params) =>
      azureAggregateTicketingLambda(API, params),
    internalCheckCodeLambda: (params) => internalCheckCodeLambda(API, params),
    internalCheckCodesBeforeOrderLambda: (params) =>
      internalCheckCodesBeforeOrderLambda(API, params),
    develonAggregatePersonalTicketLambda: (params) =>
      develonAggregatePersonalTicketLambda(API, params),
    azureSalesforceCustomerLambda: (params) =>
      azureSalesforceCustomerLambda(API, params),
    getTicketPdf: (params) => getTicketPdf(API, params),
    /**
     * Generic Endpoint
     */
    customApiLambda: (params) => customApiLambda(API, params),
    /**
     * Agenda
     */
    agendaHandler: (params, path) => agendaHandler(API, params, path),
    //TODO: move out -> useDrupalMail hook
    azureAnalyticsTicketHandler: (params) =>
      azureAnalyticsTicketHandler(API, params),
    //TODO: move out -> useDrupalMail hook
    sendMail: (
      mail_type,
      mail_to,
      brand_message,
      brand_name,
      br_date,
      br_topic,
      br_image,
      br_start,
      br_end,
      timezone,
      langcode,
      is_live_chat
    ) =>
      sendMailPost(API, {
        mail_type,
        mail_to,
        brand_message,
        brand_name,
        br_date,
        br_topic,
        br_image,
        br_start,
        br_end,
        timezone,
        langcode,
        is_live_chat,
      }),
    sendMailAgenda: (
      userName,
      userLastname,
      userEmail,
      userSalesforceId,
      userCompany,
      brandName,
      brandSalesforceId,
      brandEmail,
      date,
      start,
      end,
      pavillion,
      stand,
      referentName,
      note,
      type
    ) =>
      sendMailAgendaPost(API, {
        userName,
        userLastname,
        userEmail,
        userSalesforceId,
        userCompany,
        brandName,
        brandSalesforceId,
        brandEmail,
        date,
        start,
        end,
        pavillion,
        stand,
        referentName,
        note,
        type,
      }),
  },
  standardAPI: API,
};
